module.exports = __webpack_public_path__ + "static/media/u32_4.f8376a89.mp3";